(ns teamoesterreich.admin-mode.data.training
  (:require [teamoesterreich.ajax :as ajax]
            [goog.json :as json]
            [clojure.walk]
            [teamoesterreich.view-state :as vstate]
            [teamoesterreich.admin-mode.data.rights :as d-rights]
            [teamoesterreich.admin-mode.data.backend :as backend]
            [teamoesterreich.util.log :as log]))



(defn get-training-list-elements [done-fn]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/training-event?comfort=1")
                  (fn [r-list status]
                    ;(log/debug "training-list-elements done" r-list status)
                    (when (= status 200)
                      (done-fn (into {} (map (fn [e] [(get e "trainingEvent-uuid") (clojure.walk/keywordize-keys e)]) (js->clj (json/parse r-list))))
                               )))))





(defn <training-load [uuid done-fn]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/training-event/" uuid "/details")
                  (fn [r-list status]
                    (log/debug "training-list-get-training-details done" r-list status)
                    (when (= status 200)
                      (done-fn (clojure.walk/keywordize-keys (js->clj (json/parse r-list))))))))

(defn >new-training [name done-fn]
  (ajax/auth-post> (backend/get-auth) (str backend/BASE_URL "/training-event")
                   (ajax/serialize {:trainingEvent-active    true
                                    :trainingEvent-published false
                                    :trainingEvent-orgId     (first (d-rights/get-rights-orgId-filter d-rights/TRAINING))
                                    :trainingEvent-category  "Ausbildung"
                                    :trainingEvent-status    "created"
                                    :trainingEvent-name      name})
                   (fn [r-list status]
                     (log/debug "training-list-get-training-details done" r-list status)
                     (if (= status 200)
                       (done-fn (clojure.walk/keywordize-keys (js->clj (json/parse r-list))))
                       (done-fn {:error (str "Fehler: Datensatz konnte nicht angelegt werden! " status)}
                                )))))



(defn >training-save [uuid data done-fn]
  (ajax/auth-put> (backend/get-auth) (str backend/BASE_URL "/training-event/" uuid)
                  (ajax/serialize data)
                  (fn [r-list status]
                    (log/debug ">training-save done" r-list status)
                    (if (= status 200)
                      (done-fn (clojure.walk/keywordize-keys (js->clj (json/parse r-list))))
                      (done-fn {:error (str "Fehler: Datensatz konnte nicht angelegt werden! " status)}
                               )))))

(defn >new-training-slot [uuid name done-fn]
  (ajax/auth-post> (backend/get-auth) (str backend/BASE_URL "/training-event/" uuid "/add-slot")
                   (ajax/serialize {:trainingSlot-name name})
                   (fn [r-list status]
                     (log/debug ">add-slot done" r-list status)
                     (done-fn)
                     )))

(defn >training-slot-save [uuid data done-fn]
  (ajax/auth-put> (backend/get-auth) (str backend/BASE_URL "/training-slot/" uuid)
                  (ajax/serialize data)
                  (fn [r-list status]
                    (log/debug ">training-slot-save done" r-list status)
                    (if (= status 200)
                      (done-fn (clojure.walk/keywordize-keys (js->clj (json/parse r-list))))
                      (done-fn {:error (str "Fehler: Datensatz konnte nicht angelegt werden! " status)}
                               )))))


(defn >training-send-test-briefing [uuid tomId]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/training-event/" uuid "/send-test-briefing?tomId=" tomId)
                  (fn [r-list status]
                    (log/debug ">training-send-test-alarm done" r-list status))))

(defn >training-send-test-invitation [uuid tomId]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/training-event/" uuid "/send-test-invitation?tomId=" tomId)
                  (fn [r-list status]
                    (log/debug ">training-send-test-invitation done" r-list status))))

(defn >training-send-invitation [uuid & [tomId]]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/training-event/" uuid "/send-invitation?tomId=" (or tomId "all"))
                  (fn [r-list status]
                    (log/debug ">training-send-test-invitation done" r-list status))))




(defn training-list-update [& [on-finished]]
  (let [uuid (get-in @vstate/app-state [:selected-training :trainingEvent-uuid])]
    (<training-load uuid (fn [response]
                           (swap! vstate/app-state assoc :selected-training response)
                           (when on-finished (on-finished))
                           ))))

(defn training-update [& [on-finished]]
  (let [uuid (get-in @vstate/app-state [:selected-training :trainingEvent-uuid])]
    (<training-load uuid (fn [response]
                           (swap! vstate/app-state assoc :selected-training response)
                           (when on-finished (on-finished))
                           ))))




















